import React, { useState, useEffect } from "react";
import "./Auth.css";

const Auth = () => {

  return (
    <div className="auth-container">
   
    </div>
  );
};

export default Auth;
